import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loading } from "@/lib/ui";
import AdminLayout from "@/components/AdminLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import UsersPage from "@/pages/Users";
import ShopsPage from "@/pages/Shops";
import CatalogPage from "@/pages/Catalog";
import OrdersPage from "@/pages/Orders";
import DeliveryPage from "@/pages/Delivery";
import CouponsPage from "@/pages/Coupons";
import ReferralsPage from "@/pages/Referrals";
import ModerationPage from "@/pages/Moderation";
import ServiceAreasPage from "@/pages/ServiceAreas";
import SettingsPage from "@/pages/Settings";
import CommissionPage from "@/pages/Commission";
import EarningsPage from "@/pages/Earnings";
import CompliancePage from "@/pages/Compliance";
import RolesPage from "@/pages/Roles";
import LogsPage from "@/pages/Logs";
import DataManagementPage from "@/pages/DataManagement";
import PayoutsPage from "@/pages/Payouts";
import ShopCategoriesPage from "@/pages/ShopCategories";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-background"><Loading label="Authenticating…" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<Protected><AdminLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="shops" element={<ShopsPage />} />
            <Route path="catalog" element={<CatalogPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="delivery" element={<DeliveryPage />} />
            <Route path="coupons" element={<CouponsPage />} />
            <Route path="referrals" element={<ReferralsPage />} />
            <Route path="moderation" element={<ModerationPage />} />
            <Route path="service-areas" element={<ServiceAreasPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="commission" element={<CommissionPage />} />
            <Route path="earnings" element={<EarningsPage />} />
            <Route path="compliance" element={<CompliancePage />} />
            <Route path="roles" element={<RolesPage />} />
            <Route path="logs" element={<LogsPage />} />
            <Route path="data" element={<DataManagementPage />} />
            <Route path="payouts" element={<PayoutsPage />} />
            <Route path="shop-categories" element={<ShopCategoriesPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
